import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import axios from 'axios';
import config from '../config';

const Login = ({ onLogin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${config.API_URL}/api/auth/login`, formData);
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      onLogin(user);
      navigate(config.ADMIN_PANEL_PATH);
    } catch (err) {
      setError(err.response?.data?.error || t('login.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__panel">
        <div className="login-page__brand">
          <Link to="/" className="site-brand" style={{ color: 'var(--ink)', justifyContent: 'center' }}>
            <span className="site-brand__mark" style={{ color: 'var(--ink)' }}>Avto Tarix</span>
            <span className="site-brand__dot" />
            <span className="site-brand__tld" style={{ color: 'var(--mute)' }}>.uz</span>
          </Link>
          <h1 className="login-page__title">{t('login.title')}</h1>
          <p className="login-page__lead">{t('login.subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-page__form">
          <div className="form-group">
            <label className="form-label" htmlFor="login-username">
              {t('login.username')}
            </label>
            <input
              id="login-username"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="form-input"
              placeholder={t('login.usernamePlaceholder')}
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="login-password">
              {t('login.password')}
            </label>
            <div className="login-page__password">
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-input"
                placeholder={t('login.passwordPlaceholder')}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-page__toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn btn-primary login-page__submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
                {t('login.logging')}
              </>
            ) : (
              t('login.login')
            )}
          </button>
        </form>

        <p className="login-page__note">{t('login.adminOnly')}</p>
      </div>
    </div>
  );
};

export default Login;
